import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DateInputComponent } from './date-input/date-input.component';
import { DestinationSelectComponent } from './destination-select/destination-select.component';
import { TravelDatesComponent } from './travel-dates/travel-dates.component';
import { BooleanQuestionComponent } from './boolean-question/boolean-question.component';
import { ConfirmTermsComponent } from './confirm-terms/confirm-terms.component';
import { StepperComponent } from './stepper/stepper.component';
import { StepperIcon } from './stepper/stepper-icon';
import { StepperHorizontalComponent } from './stepper/stepper-horizontal.component';
import { OptionSelectComponent } from './option-select/option-select.component';
import { HintDialogComponent } from './hint-dialog/hint-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { PreExistingConditionComponent } from './pre-existing-condition/pre-existing-condition.component';
import { ImageComponent } from './image/image.component';
import { ExpiryDateInputComponent } from './expiry-date-input/expiry-date-input.component';
import { InformationDialogComponent } from './information-dialog/information-dialog.component';
import { AssessmentCoverComponent } from './assessment-cover/assessment-cover.component';
import { FrameComponent } from './frame/frame.component';
import { TravelDateRangeComponent } from './travel-daterange/travel-daterange.component';
import { TravelDateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { TravelDestinationSelectComponent } from './travel-destination-select/travel-destination-select.component';
import { TravelDestinationDialogComponent } from './travel-destination-dialog/travel-destination-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ApDialogContainer } from './dialog-container/dialog-container.component';
import { FullScreenDialogComponent } from './full-screen-dialog/full-screen-dialog.component';

export * from './header/header.component';
export * from './footer/footer.component';
export * from './date-input/date-input.component';
export * from './destination-select/destination-select.component';
export * from './travel-dates/travel-dates.component';
export * from './boolean-question/boolean-question.component';
export * from './confirm-terms/confirm-terms.component';
export * from './stepper/stepper.component';
export * from './stepper/step';
export * from './stepper/stepper-icon';
export * from './stepper/stepper-horizontal.component';
export * from './option-select/option-select.component';
export * from './hint-dialog/hint-dialog.component';
export * from './pre-existing-condition/pre-existing-condition.component';
export * from './image/image.component';
export * from './expiry-date-input/expiry-date-input.component';
export * from './error-dialog/error-dialog.component';
export * from './information-dialog/information-dialog.component';
export * from './assessment-cover/assessment-cover.component';
export * from './frame/frame.component';
export * from './travel-destination-select/travel-destination-select.component';
export * from './travel-destination-dialog/travel-destination-dialog.component';
export * from './confirm-dialog/confirm-dialog.component';
export * from './dialog-container/dialog-container.component';
export * from './full-screen-dialog/full-screen-dialog.component';;


export const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  DateInputComponent,
  DestinationSelectComponent,
  TravelDatesComponent,
  BooleanQuestionComponent,
  ConfirmTermsComponent,
  StepperComponent,
  StepperHorizontalComponent,
  StepperIcon,
  OptionSelectComponent,
  ConfirmDialogComponent,
  HintDialogComponent,
  ErrorDialogComponent,
  PreExistingConditionComponent,
  ImageComponent,
  ExpiryDateInputComponent,
  InformationDialogComponent,
  AssessmentCoverComponent,
  FrameComponent,
  TravelDateRangeComponent,
  TravelDateRangePickerComponent,
  TravelDestinationSelectComponent,
  TravelDestinationDialogComponent,
  FullScreenDialogComponent,
  ApDialogContainer
];

export const ENTRY_COMPONENTS = [
  ConfirmDialogComponent,
  HintDialogComponent,
  ErrorDialogComponent,
  InformationDialogComponent,
  TravelDateRangePickerComponent,
  TravelDestinationDialogComponent,
  FullScreenDialogComponent,
  ApDialogContainer
];
